import { Button } from '@components/ui/button';
import { AlertDialogFooter } from '@components/ui/alert';
import { useTranslation } from 'react-i18next';
import { InternalScheduleActionDialogActionsProps } from '../types';

export const InternalScheduleActionDialogActions = ({
  type,
  onCancel,
  onConfirm,
  disabled,
}: InternalScheduleActionDialogActionsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'actions' });

  return (
    <AlertDialogFooter>
      <Button disabled={disabled} onClick={onCancel} variant="secondary">
        {t('cancel')}
      </Button>
      <Button disabled={disabled} onClick={onConfirm} variant="danger">
        {t(type === 'overlap' ? 'confirm' : 'scheduleAnyway')}
      </Button>
    </AlertDialogFooter>
  );
};
